import { createFileRoute } from "@tanstack/react-router"
import { childrenQueryOptions } from "@/features/children/api/children.queries"
import { getSelectedChildId } from "@/features/children/useSelectedChild"
import { dashboardQueryOptions } from "@/features/dashboard/api/dashboard.queries"
import { DashboardPage } from "@/features/dashboard/DashboardPage"

export const Route = createFileRoute("/_app/")({
  loader: async ({ context }) => {
    const children = await context.queryClient.ensureQueryData(childrenQueryOptions)
    const childId = getSelectedChildId(children)
    if (childId) {
      await context.queryClient.ensureQueryData(dashboardQueryOptions(childId))
    }
  },
  component: DashboardPage,
})
